import {
  distanceToPoint,
  intersectLine,
  lineSegemntDistance
} from "./lineSegment.js";
import Line3 from "./line3";

const line = {
  distanceToPoint,
  intersectLine,
  lineSegemntDistance,
  Line3
};

export default line;
